import React, { useState, useEffect } from "react";
import { Grid, Paper, IconButton } from "@material-ui/core";
import { Delete, Edit } from "@material-ui/icons";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import axios from "axios";
import {
  TableContainer,
  FormControlLabel,
  Checkbox,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Button,
  Box,
  Dialog,
  Typography,
  DialogContent,
  TableBody,
  DialogTitle,
  Autocomplete,
  FormControl,
  DialogActions,
  MenuItem,
  TextField,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import {
  getCostCenterData,
  getg_laccount_Search,
  getEmployeeByCostCenter,
  getVendorAdvance,
} from "../../actions";
import { getTaxCode } from "../../actions";
import GetChargeAccount from "../Dropdowns/GetChargeAccount";
import CostCenter from "../Dropdowns/CostCenter";
import VendorCode from "../Dropdowns/VenderCode";
import VendorCodeImport from "../Dropdowns/VenderCodeImport";
import isAboveToday from "../../../../Functions/isAboveToday";
import isOldDateValidate from "../../../../Functions/isOldDateValidate";
import { addZeroes, formatDateTimeForBackend } from "../../../../Functions";
import OldDateWarning from "../InvoiceGuidLines/OldDateWarning";
import getParameterByName from "../../../../Functions/functions";
import moment from "moment";
import POAlertDialog from "./PoTableAlert";
import Select from "react-select";
import jwt from "jsonwebtoken";
import "./style.css";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },
    // tablebody: {
    //   "&.MuiTableRow-root:last-child td": {
    //     borderLeft: "1px solid #000",
    //   },
    // },
  },
});

const PaymentDetailTable = ({
  formState,
  formState1,
  setImportPaymentDetail,
  setFormState,
  invoiceData,
  multipleData,
  vendor,
  inv_amount,
  edit,
  disable,
  // Invoice_decription,
}) => {
  const [open, setOpen] = useState(false);
  const [openInvalidWarningDate, setOpenInvalidWarningDate] = useState(false);
  const [alertMessage, setAlertMessage] = useState(false);
  const [erralertMessage, setErrAlertMessage] = useState("");
  const [vendorblock, setvendorblock] = useState(false);
  const [taxCodeList, setTaxCodeList] = useState([]);
  const [taxCodeListLoading, setTaxCodeListLoading] = useState(false);
  const [costLoading, setCostLoading] = useState(false);
const [isError , setError] = useState(false)
  const status = getParameterByName("status");
  const [paymentItem, setPaymentItem] = useState({
    ReferencePostingKey:'',
    advanceDocNo : "",
    advanceAmount:0,
    inv_Payment_Id: 0,
    invoice_Id: parseInt(formState1?.invoice_Id),
    postingKey: "21",
    sglInd: "",
    tType: "",
    // paymentTerms: multipleData?.paymentTerms?.[0]?.ReferenceCode || "",
    paymentTerms: formState1?.invoice_Payment?.paymentTerms || "",
    paymentDays: "",
    paymentMethod:
      formState1?.demandType === "Deposit"
        ? "3"
        : formState1?.invoice_Payment?.paymentMethod,
    paymentMethSupp:
      formState1?.demandType === "Deposit"
        ? "P"
        : formState1?.invoice_Payment?.paymentMethSupp,
    individualPayee: true,
    account: "",
    accountName: "",
    amount: 0,
    taxAmount: Number(invoiceData?.taxAmount || 0),
    taxAmount_formatted: Number(invoiceData?.taxAmount)?.toLocaleString(),
    dueOn: moment().format("YYYY-MM-DD"),
    taxCode: invoiceData?.taxCode,
    description: formState1?.invoice_Desc,
    order: "",
    costCenter: "",
    wbsElement: "",
    profitCenter: "",
    createdBy: "",
    createdDate: moment().format("YYYY-MM-DD"),

    vendor_Code: "",
    glAccount: "",
    rowId: "",
  });


  const [costCenterList, setCostCenterList] = useState([]);
  const [costCenterLoading, setCostCenterLoading] = useState(false);
  const [vendorList, setVendorList] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("user_token");
  const user = jwt.decode(token);
  const [sortedOptions, setSortedOptions] = useState(multipleData?.sglInd);
  const [mappedData , setMappedData] = useState([])
  const [vendorAdvance , setVendorAdvance] = useState([])
  const [allAdvaces , setAllAdvances] = useState([])
  const [docNos , setDocNos] = useState([])

  const sortOptionsBySearchTerm = (searchTerm) => {
    const filteredOptions = multipleData?.sglInd.filter((option) => {
      return option?.ReferenceCode.toLowerCase().startsWith(
        searchTerm.toLowerCase()
      );
    });

    const otherOptions = multipleData?.sglInd.filter((option) => {
      return !option?.ReferenceCode.toLowerCase().startsWith(
        searchTerm.toLowerCase()
      );
    });

    const sortedOptions = [...filteredOptions, ...otherOptions];
    setSortedOptions(sortedOptions);
  };
  const getVendorDetail = async (user, setUserData) => {
    setLoading(true);
    await axios({
      method: "get", //you can set what request you want to be
      url: `${
        process.env.REACT_APP_API_URL
      }/api/InvoiceDetails/getVendorDetails/${user ? user : null}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
    })
      .then(async (res) => {
        const finded = res.data?.find((x) => x.Vendor_Code === user);
        setUserData.Vendor = finded;
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);

        // setErrorMessage("Invalid username or password");
      });
  };
  const clearState = (postingKey) => {
    
    setPaymentItem((formState) => ({
      ...formState,
      inv_Payment_Id: 0,
      invoice_Id: parseInt(formState1?.invoice_Id),
      postingKey: postingKey ? postingKey : "21",
      sglInd: "",
      tType: "",
      paymentDays: "",
      paymentTerms: formState1?.invoice_Payment?.paymentTerms || "",
      paymentMethod:
        formState1?.demandType === "Deposit"
          ? "3"
          : formState1?.invoice_Payment?.paymentMethod,
      paymentMethSupp:
        formState1?.demandType === "Deposit"
          ? "P"
          : formState1?.invoice_Payment?.paymentMethSupp,
      individualPayee: true,
      account: "",
      // amount: 0,
      taxAmount:
        postingKey === "40" || postingKey === "01" || postingKey === "70" || postingKey === "75"
          ? 0
          : Number(invoiceData?.taxAmount || 0),
      taxAmount_formatted:
        postingKey === "40" || postingKey === "01" || postingKey === "70" || postingKey === "75"
          ? Number(0)?.toLocaleString()
          : Number(invoiceData?.taxAmount)?.toLocaleString(),
      dueOn: moment().format("YYYY-MM-DD"),
      taxCode: invoiceData?.taxCode,
      // description: `${Invoice_decription}`,
      description: "",
      order: "",
      costCenter: "",
      wbsElement: "",
      profitCenter: "",
      createdBy: "",
      createdDate: moment().format("YYYY-MM-DD"),
      amount_formatted: "",
      vendor_Code: "",
      glAccount: "",
      rowId: postingKey ? paymentItem?.rowId : "",
      advanceDocNo : "",
      advanceAmount:0,
      ReferencePostingKey: '',
    }));
  };
  const myStyle = {
    inputField: {
      padding: "8.5px",
      width: "100%",
      display: "block",
      minWidth: 0,

      fontFamily: "Arial",
      fontSize: 16,
      borderRadius: 4,
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#B4B4B4",
      backgroundColor: disable && "white",
      "&:hover": {
        borderColor: "#000",
        cursor: "text",
      },
    },
  };
  useEffect(() => {
    if (formState1?.invoice_Payment?.paymentTerms) {
      setPaymentItem((paymentItem) => ({
        ...paymentItem,
        paymentTerms: formState1?.invoice_Payment?.paymentTerms || "",
      }));
    }
  }, [formState1?.invoice_Payment?.paymentTerms]);

  const handleClickOpen = () => {
    clearState();
    setOpen(true);
  };

  const deleteInput = (index) => {
    const filteredData = formState?.invoice_Payment_Details?.filter(
      (x, i) => i !== index
    );
    setImportPaymentDetail((formState) => ({
      ...formState,
      invoice_Payment_Details: filteredData,
    }));
  };
  const editItem = (item) => {
    setOpen(true);

  
    setPaymentItem((paymentItem) => ({
      ...paymentItem,
      inv_Payment_Id: Number(item?.inv_Payment_Id),
      invoice_Id: Number(item?.invoice_Id),
      postingKey: item?.postingKey,
      sglInd: item?.sglInd || item?.sGLInd,
      tType: item?.tType,
      paymentTerms: item?.paymentTerms,
      paymentDays: item?.paymentDays,
      // paymentMethod: item?.paymentMethod,
      // paymentMethSupp: item?.paymentMethSupp,
      paymentMethod: item?.paymentMethod
        ? item?.paymentMethod
        : formState1?.demandType === "Deposit"
        ? "3"
        : formState1?.invoice_Payment?.paymentMethod,
      paymentMethSupp: item?.paymentMethSupp
        ? item?.paymentMethSupp
        : formState1?.demandType === "Deposit"
        ? "P"
        : formState1?.invoice_Payment?.paymentMethSupp,
      individualPayee: item?.individualPayee,
      account: item?.account,
      amount: Number(item?.amount),
      taxAmount: Number(item?.taxAmount),
      taxAmount_formatted: Number(item?.taxAmount)?.toLocaleString(),
      dueOn: item?.dueOn,
      // taxCode: item?.taxCode || invoiceData?.taxCode,
      taxCode: item?.taxCode,

      description: item?.description,
      order: item?.order,
      costCenter: item?.costCenter?.split("-")[0].trim() || item?.costCenter,
      wbsElement: item?.wbsElement,
      profitCenter: item?.profitCenter,
      createdBy: item?.createdBy,
      createdDate: item?.createdDate,
      // vendor_Code: ,
      vendor_Code: formState1.isHR
        ? { Vendor_Code: item?.account, Vendor_Name: item?.accountName }
        : { Vendor_Code: item?.account, Vendor_Name: item?.accountName },

      // vendor_Code: item?.vendor_Code,
      glAccount: item?.account,
      accountName: item?.accountName,
      rowId: item?.rowId,
      amount_formatted: Number(item?.amount)?.toLocaleString(),
      advanceDocNo : item?.advanceDocNo ? item?.advanceDocNo : "",
      advanceAmount : Number(item?.advanceAmount)?.toLocaleString(),
      ReferencePostingKey:'',
      // ReferenceProp:
      //   item?.ReferenceProp ||
      //   multipleData?.postingKey?.find(
      //     (x) =>
      //       x?.ReferenceCode ===
      //       (item?.postingKey === "01" ? "40" : item?.postingKey)
      //   )?.ReferenceProp3 ||
      //   "",
    }));
  };
  const propertiesName = {
    wbsElement: "wbsElement",
    // profitCenter: "profitCenter",
    order: "order",
    taxAmount: "taxAmount",
    accountName: "accountName",
    // amount: "amount",

    description: "description",
    // costCenter: "costCenter",
  };
  const postingKey = {
    a40: "Debit",
    a21: "Debit",
    a29: "Debit",
    a70: "Debit",

    a39: "Credit",
    a75: "Credit",
    a50: "Credit",
    a31: "Credit",
  };
  const addItem = async () => {
    let _account = "";
    let _paymentItem = paymentItem;
    for (let i = 0; i < multipleData?.postingKey?.length; i++) {
      const pTerms = multipleData?.postingKey[i];
      if (pTerms?.ReferenceCode === paymentItem?.postingKey) {
        _paymentItem.ReferenceProp =
          paymentItem?.postingKey === "01"
            ? multipleData?.postingKey?.find((x) => x?.ReferenceCode === "40")
                ?.ReferenceProp3 ||
              pTerms?.ReferenceProp3 ||
              ""
            : pTerms?.ReferenceProp3 || "";
        if (pTerms.ReferenceProp1 === "V") {
          _account =
            paymentItem.vendor_Code?.Vendor_Code || paymentItem.vendor_Code;
          _paymentItem.account = _account;
        }
        // if(pTerms.ReferenceProp1 === "G"){
        //   _account = paymentItem.vendor_Code
        // }
        // if(pTerms.ReferenceProp1 === "A"){
        //   _account = paymentItem.vendor_Code
        // }
      }
    }

    let tempArray = formState1.invoice_Accounts;
    if (_paymentItem?.rowId) {
      let newData = [];
      for (let i = 0; i < formState?.invoice_Payment_Details?.length; i++) {
        let x = formState?.invoice_Payment_Details[i];

        if (x.rowId === _paymentItem.rowId) {
          const obj = {};
          const findedIndex = formState1?.invoice_Accounts?.findIndex(
            (x) => x.rowId === _paymentItem.rowId
          );
          obj["accountName"] = _paymentItem?.accountName;
          obj["advanceDocNo"] = _paymentItem?.advanceDocNo;
          obj["advanceAmount"] = _paymentItem?.advanceAmount;
          for (const [key, value] of Object.entries(x)) {
            obj[key] = _paymentItem[key];
            if (propertiesName[key]) {
              tempArray[parseInt(findedIndex)] = {
                ...formState1.invoice_Accounts[parseInt(findedIndex)],
                [key]: _paymentItem[key],
              };
            } else if (key === "account") {
              tempArray[parseInt(findedIndex)] = {
                ...formState1.invoice_Accounts[parseInt(findedIndex)],
                glAccount:
                  _paymentItem[key] + " - " + _paymentItem?.accountName,
              };
            } else if (key === "postingKey") {
              tempArray[parseInt(findedIndex)] = {
                ...formState1.invoice_Accounts[parseInt(findedIndex)],
                accountType: postingKey["a" + _paymentItem[key]],
              };
            } else if (key === "amount") {
              if (formState1.invoice_Accounts.length === 0) {
                // setFormState((formState1) => ({
                //   ...formState1,
                //   invoice_Amount: _paymentItem[key],
                // }));
              }
              tempArray[parseInt(findedIndex)] = {
                ...formState1.invoice_Accounts[parseInt(findedIndex)],
                amount: Number(_paymentItem[key]),
              };
            } else if (key === "profitCenter") {
              tempArray[parseInt(findedIndex)] = {
                ...formState1.invoice_Accounts[parseInt(findedIndex)],
                profitCenter: Number(_paymentItem[key]),
              };
            } else if (key === "taxCode") {
              tempArray[parseInt(findedIndex)] = {
                ...formState1.invoice_Accounts[parseInt(findedIndex)],
                stCode: _paymentItem[key],
                taxCode: _paymentItem[key],
              };
            } else if (key === "costCenter") {
              let costCenter = { costCenterData: "" };

              await getEmployeeByCostCenter(
                _paymentItem[key],
                setCostLoading,
                costCenter
              );
              tempArray[parseInt(findedIndex)] = {
                ...formState1.invoice_Accounts[parseInt(findedIndex)],
                costCenter: _paymentItem[key] + " - " + _paymentItem?.ccName,
                costCenterOwner: _paymentItem[key]
                  ? costCenter.costCenterData.employeeCode
                    ? costCenter.costCenterData.employeeCode
                    : "No Found"
                  : "",
                CostCenterOwnerName: _paymentItem[key]
                  ? costCenter.costCenterData.employeeName
                    ? costCenter.costCenterData.employeeName
                    : "Not Found"
                  : "",
              };
            }
          }
          newData.push(obj);
        } else {
          newData.push(x);
        }
      }
      setFormState((formState) => ({
        ...formState,
        invoice_Accounts: tempArray,
      }));
      setImportPaymentDetail({
        ...formState,
        invoice_Payment_Details: [
          ...newData,
          // paymentItem,
        ],
      });
    } else {
      _paymentItem.rowId = Math.random();
      setImportPaymentDetail({
        ...formState,
        invoice_Payment_Details: [
          ...formState.invoice_Payment_Details,
          {
            ..._paymentItem,
            accountName:
              _paymentItem.postingKey == "31" ||
              _paymentItem.postingKey == "21" ||
              _paymentItem.postingKey == "29"
                ? _paymentItem.accountName
                : _paymentItem.accountName,
          },
          // _paymentItem,
          // paymentItem,
        ],
      });
    }

    setOpen(false);
    clearState();
  };
  const classes = useStyles();
  const handleClose = () => {
    clearState();
    setOpen(false);
  };

  const changeHandler = async (e) => {
    const { name, value } = e.target;
    let ab = { Vendor: "" };

    if (name === "glAccount") {
      await getg_laccount_Search(value, () => {}, ab);
      setPaymentItem((formState) => ({
        ...formState,
        account: value,
        accountName: ab?.Vendor?.ShortText,
      }));
    } else if (name === "costCenter") {
      setPaymentItem((formState) => ({
        ...formState,
        costCenter: value,
        ccName: e.target.ccName,
      }));
    } else if (name === "vendor_Code") {
      let getVendor = { Vendor: "" };
      setPaymentItem((paymentItem) => (
        {
      ...paymentItem,
      advanceAmount : 0,
      advanceDocNo : ""
    })
      )
      await getVendorDetail(value?.Vendor_Code, getVendor, () => {});
      setPaymentItem((formState) => ({
        ...formState,
        vendor_Code: value,
        accountName: getVendor?.Vendor?.Vendor_Name,
      }));
    } else if (name === "amount") {
      // const decimalCount = (value?.split(".")[1] || []).length;
      // setPaymentItem((formState) => ({
      //   ...formState,
      //   amount: decimalCount > 2 ? Number(value).toFixed(2) : value,
      // }));
      let cleanedValue = value.replace(/[^\d.]/g, "");
      const decimalIndex = cleanedValue.indexOf(".");
      if (decimalIndex !== -1) {
        cleanedValue = cleanedValue.substring(0, decimalIndex + 3);
      }

      // Check if the input is a valid number
      if (/^\d*\.?\d*$/.test(cleanedValue) || cleanedValue === "") {
        // Apply formatting logic for integers and decimals
        const formattedValue =
          cleanedValue === ""
            ? cleanedValue
            : cleanedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ","); // Add commas for thousands


             const advanceAmt = Number(paymentItem?.advanceAmount || 0);
    const enteredAmt = Number(cleanedValue || 0);

    // if(paymentItem?.postingKey == "39" && formState1?.adjustAdvance && paymentItem?.sglInd == "A"){
    //   if (enteredAmt > advanceAmt ) {
    //   // alert("Amount cannot be greater than Advance Amount");
    //   setError(true)
    //   return; // prevent updating state
    // }
   
    // }
    //  else {
    //   setError(false)
    // }

        setPaymentItem((prevState) => ({
          ...prevState,
          [name]: cleanedValue,
          [`${name}_formatted`]: formattedValue,
          // [name]: formattedValue,
        }));
      }
    } else if (name === "taxAmount") {
      let cleanedValue = value.replace(/[^\d.]/g, "");
      const decimalIndex = cleanedValue.indexOf(".");
      if (decimalIndex !== -1) {
        cleanedValue = cleanedValue.substring(0, decimalIndex + 3);
      }

      // Check if the input is a valid number
      if (/^\d*\.?\d*$/.test(cleanedValue) || cleanedValue === "") {
        // Apply formatting logic for integers and decimals
        const formattedValue =
          cleanedValue === ""
            ? cleanedValue
            : cleanedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ","); // Add commas for thousands

        setPaymentItem((prevState) => ({
          ...prevState,
          [name]: cleanedValue,
          [`${name}_formatted`]: formattedValue,
          // [name]: formattedValue,
        }));
      }
    } else {
      setPaymentItem((formState) => ({
        ...formState,
        [name]: value,
      }));
    }
  };

useEffect(() => {
  if (paymentItem?.advanceDocNo) {
    const matchedAdvance = allAdvaces?.find(
      (item) => item.doC_NO === paymentItem.advanceDocNo
    );
    setPaymentItem((prev) => ({
      ...prev,
      advanceAmount: matchedAdvance ? (matchedAdvance?.AMT_LC || matchedAdvance?.amT_LC) : 0,
    }));
  }
}, [allAdvaces, paymentItem?.advanceDocNo]);

useEffect(()=>{
  const docNosArray = allAdvaces.map(item =>  (item?.DOC_NO || item?.doC_NO));
  setDocNos(docNosArray);

},[allAdvaces])

// useEffect(()=>{
//   if(paymentItem?.postingKey == "39" && formState1?.adjustAdvance && paymentItem?.sglInd == "A"){
//   getVendorAdvance(formState1?.vendor_Code, setAllAdvances, setCostLoading , "" );
//   }
// },[formState1?.vendor_Code , paymentItem?.vendor_Code?.Vendor_Code , formState1?.adjustAdvance , paymentItem?.postingKey , paymentItem?.sglInd  ])
  
// useEffect(()=>{
//     if(paymentItem?.postingKey == "39" && formState1?.adjustAdvance && paymentItem?.sglInd == "A"){
//         const advanceAmt = Number(paymentItem?.advanceAmount || 0);
//       if(paymentItem?.amount > advanceAmt){
//         setError(true)
//       setPaymentItem((formState) => ({
//         ...formState,
      
//         amount_formatted : "",
//       }));
//       }
//       else {
//         setError(false)
//       }
//     }
//       else {
//         setError(false)
//       }

//   },[paymentItem?.sglInd , paymentItem?.postingKey , formState1?.adjustAdvance , paymentItem?.amount_formatted  ])

  const autocompleteChangeHandler = (name, value) => {
    if (name === "postingKey") {
      // here we clear the all the field because (dom manupulation is based on it.) (need to clear state)
      clearState(value);
      // const postingKeyItem = multipleData?.postingKey?.find(
      //   (item) =>
      //     item?.ReferenceCode === (value === "01" ? "40" : value)
      // );
      // setPaymentItem((formState) => ({
      //   ...formState,
      //   [name]: value,
      //   ReferenceProp: postingKeyItem?.ReferenceProp3 || "",
      // }));
      // return;
    }
     else if(name === "advanceDocNo"){
      //  getVendorAdvance("", setVendorAdvance, setCostLoading , value);
       setPaymentItem((formState) => ({
        ...formState,
        advanceDocNo: value,
      }));   
    } 
    setPaymentItem((formState) => ({
      ...formState,
      [name]: value,
    }));
  };

  useEffect(() => {
    getCostCenterData("", setCostCenterLoading, setCostCenterList, () => {});
    getTaxCode(setTaxCodeList, setTaxCodeListLoading);
  }, []);
 
  useEffect(() => {
    setFirstTime(true);
  }, [formState1?.invoice_Amount, formState1?.invoice_Payment?.paymentTerms]);
  //  this useEffect is used to load G/L Account table data in payment detail table.
  const [firstTime, setFirstTime] = useState(true);


 
  useEffect(() => {
    const fetchData = async () => {
      if (firstTime) {
        if (!edit) {
          let items = [];
          const vendorCode = getParameterByName("vendorCode");
          // here***
          // if (!invoiceData?.isPCDV) {
          for (let i = 0; i < invoiceData?.GLInvoice_Accounts?.length; i++) {
            const a = invoiceData?.GLInvoice_Accounts[i];
            let ab = { Vendor: "" };
            // await getg_laccount_Search(a.glAccount, () => {}, ab);

            const resolvedPostingKey =
              a?.accountType === "Debit" &&
              formState1.invoice_Type === "Final Settlement - Distributor"
                ? "01"
                : a?.accountType === "Debit"
                ? "40"
                : a?.accountType === "Credit"
                ? "50"
                : "";

            const resolvedReferenceProp = multipleData?.postingKey?.find(
              (item) =>
                item?.ReferenceCode ===
                (resolvedPostingKey === "01" ? "40" : resolvedPostingKey)
            )?.ReferenceProp3;

            const obj = {
              inv_Payment_Id: 0,
              invoice_Id: parseInt(getParameterByName("invoiceId")),
              postingKey: resolvedReferenceProp ? resolvedReferenceProp : resolvedPostingKey,
              ReferencePostingKey: resolvedReferenceProp || "",
              sglInd: "",
              tType: "",
              // paymentTerms: multipleData?.paymentTerms[0]?.ReferenceCode,
              paymentTerms: formState1?.invoice_Payment?.paymentTerms,
              paymentDays: "",
              paymentMethod:
                formState1?.demandType === "Deposit"
                  ? "3"
                  : formState1?.invoice_Payment?.paymentMethod,
              paymentMethSupp:
                formState1?.demandType === "Deposit"
                  ? "P"
                  : formState1?.invoice_Payment?.paymentMethSupp,
              individualPayee: true,
              account: a?.glAccount.split("-")[0]?.trim(),
              accountName: a?.glAccount.split("-")[1]?.trim(),
              // accountName: ab?.Vendor?.ShortText,

              amount: a?.amount < 0 ? a?.amount * -1 : a?.amount ,
              taxAmount:
                a?.accountType === "Debit" ? 0 :  Number(invoiceData?.taxAmount),
              taxAmount_formatted:  a?.accountType === "Debit" ? 0 :Number(
                invoiceData?.taxAmount
              )?.toLocaleString(),
              dueOn: moment().format("YYYY-MM-DD"),
              taxCode: invoiceData?.taxCode,

              description: a?.description,
              order: a?.order,
              costCenter: a?.costCenter,
              wbsElement: a?.wbsElement,
              profitCenter: a?.profitCenter,
              createdBy: "",
              createdDate: new Date(),
              rowId: a?.rowId,
            };
            items.push(obj);
            const isFS = formState1.invoiceCategory?.includes(
              "Final Settlement – Death case"
            );
            if (formState1.isHR && !isFS) {
              const strObj = JSON.stringify(obj);
              const parObj = JSON.parse(strObj);
              parObj.rowId = Math.random();
              parObj.postingKey = "31";
              parObj.account = a.vendorCode
                ? a.vendorCode.split("-")[0]?.trim()
                : "";
              parObj.accountName = a.vendorCode
                ? a.vendorCode.split("-")[1]?.trim()
                : "";
              const _vendorCode = a.vendorCode
                ? a.vendorCode.split("-")[0]?.trim()
                : "";
              if (_vendorCode) {
                await axios({
                  method: "get", //you can set what request you want to be
                  url: `${
                    process.env.REACT_APP_API_URL
                  }/api/InvoiceDetails/getVendorDetails/${
                    _vendorCode ? _vendorCode : null
                  }`,
                  headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                      "user_token"
                    )}`,
                    "Content-Type": "application/json",
                  },
                })
                  .then(async (res) => {
                    if (res.data.length > 0) {
                      parObj.paymentTerms = res.data[0]?.Payment_Terms;
                      let paymentMethod = "";
                      let paymentMethodSupp = "";

                      if (user.Location === "1") {
                        // thsi is for MPAS
                        if (
                          !res.data[0]?.Bank_Key ||
                          res.data[0]?.Bank_Key === ""
                        ) {
                          paymentMethod = "1";
                          paymentMethodSupp = "C";
                        } else if (res.data[0]?.Bank_Key?.includes("SCB")) {
                          paymentMethod = "W";
                          paymentMethodSupp = "C";
                        } else {
                          paymentMethod = "V";
                          paymentMethodSupp = "C";
                        }
                      } else {
                        if (
                          !res.data[0]?.Bank_Key ||
                          res.data[0]?.Bank_Key === ""
                        ) {
                          paymentMethod = "1";
                          paymentMethodSupp = "C";
                        } else if (res.data[0].Bank_Key?.includes("SCB")) {
                          paymentMethod = "6";
                          paymentMethodSupp = "C";
                        } else {
                          paymentMethod = "7";
                          paymentMethodSupp = "C";
                        }
                      }
                      parObj.paymentMethod = paymentMethod;
                      parObj.paymentMethSupp = paymentMethodSupp;
                    }
                  })
                  .catch((err) => {
                    console.log(err);
                    // setErrorMessage("Invalid username or password");
                  });
              }
              items.push(parObj);
            } else if (
              formState1.isHR &&
              isFS &&
              formState1?.vendor_Details?.length > 0
            ) {
              for (let j = 0; j < formState1?.vendor_Details?.length; j++) {
                const strObj = JSON.stringify(obj);
                const parObj = JSON.parse(strObj);
                const item = formState1?.vendor_Details[j];
                parObj.rowId = Math.random();
                parObj.postingKey = "31";
                parObj.amount = item?.amount;
                parObj.account = item?.vendor_Code?.Vendor_Code
                  ? item?.vendor_Code?.Vendor_Code
                  : "";
                parObj.accountName = item.vendor_Name ? item.vendor_Name : "";
                const _vendorCode = item?.vendor_Code?.Vendor_Code
                  ? item?.vendor_Code?.Vendor_Code
                  : "";
                if (_vendorCode) {
                  await axios({
                    method: "get", //you can set what request you want to be
                    url: `${
                      process.env.REACT_APP_API_URL
                    }/api/InvoiceDetails/getVendorDetails/${
                      _vendorCode ? _vendorCode : null
                    }`,
                    headers: {
                      Authorization: `Bearer ${localStorage.getItem(
                        "user_token"
                      )}`,
                      "Content-Type": "application/json",
                    },
                  })
                    .then(async (res) => {
                      if (res.data.length > 0) {
                        parObj.paymentTerms = res.data[0]?.Payment_Terms;
                        let paymentMethod = "";
                        let paymentMethodSupp = "";

                        if (user.Location === "1") {
                          // thsi is for MPAS
                          if (
                            !res.data[0]?.Bank_Key ||
                            res.data[0]?.Bank_Key === ""
                          ) {
                            paymentMethod = "1";
                            paymentMethodSupp = "C";
                          } else if (res.data[0]?.Bank_Key?.includes("SCB")) {
                            paymentMethod = "W";
                            paymentMethodSupp = "C";
                          } else {
                            paymentMethod = "V";
                            paymentMethodSupp = "C";
                          }
                        } else {
                          if (
                            !res.data[0]?.Bank_Key ||
                            res.data[0]?.Bank_Key === ""
                          ) {
                            paymentMethod = "1";
                            paymentMethodSupp = "C";
                          } else if (res.data[0].Bank_Key?.includes("SCB")) {
                            paymentMethod = "6";
                            paymentMethodSupp = "C";
                          } else {
                            paymentMethod = "7";
                            paymentMethodSupp = "C";
                          }
                        }
                        parObj.paymentMethod = paymentMethod;
                        parObj.paymentMethSupp = paymentMethodSupp;
                      }
                    })
                    .catch((err) => {
                      console.log(err);
                      // setErrorMessage("Invalid username or password");
                    });
                }
                items.push(parObj);
              }
            }
          }
          // }
          if (invoiceData?.GLInvoice_Accounts?.length > 0) {
            setFirstTime(false);
          }
          // this item is add by default first time.
          let payment_method = "";

          let payment_method_supp = "C";

          if (user.Location === "1") {
            if (
              multipleData?.invoice_Details?.Bank_Key == null ||
              multipleData?.invoice_Details?.Bank_Key == ""
            )
              payment_method = "1";
            else if (multipleData?.invoice_Details?.Bank_Key?.includes("SCB"))
              payment_method = "W";
            else payment_method = "V";
          } else {
            if (
              multipleData?.invoice_Details?.Bank_Key == null ||
              multipleData?.invoice_Details?.Bank_Key == ""
            )
              payment_method = "1";
            else if (multipleData?.invoice_Details?.Bank_Key?.includes("SCB"))
              payment_method = "6";
            else payment_method = "7";
          }
          // if (multipleData?.invoice_Details?.IsImport && multipleData?.invoice_Details?.DemandType == "Deposit") {
          //   // multipleData.invoice_Details.IsPO = false;
          //   if(multipleData?.invoice_Details?.DemandType == 'Spare parts')
          //   multipleData?.invoice_Details?.DocumentType = 'KR';
          //   else
          //   if (multipleData?.invoice_Details?.DemandType == "Deposit")
          //     multipleData?.invoice_Details?.DocumentType = "KA";
          //   this.hotSettingsVendor.data = [{}, {}];
          // }
          // if (
          //   multipleData?.invoice_Details?.IsImport !== "False" &&
          //   multipleData?.invoice_Details?.IsPSID !== "False"
          // ) {
          //   payment_method = "6";
          //   payment_method_supp = "C";
          // } else if (
          //   multipleData?.invoice_Details?.IsImport !== "False" &&
          //   !multipleData?.invoice_Details?.IsPSID !== "False"
          // ) {
          //   payment_method = "3";
          //   payment_method_supp = "P";
          // }
          if (formState1.isImport && formState1.isPSID) {
            payment_method = "6";
            payment_method_supp = "C";
          } else if (formState1.isImport && !formState1.isPSID) {
            payment_method = "3";
            payment_method_supp = "P";
          }

          const newItem = {
            inv_Payment_Id: 0,
            invoice_Id: parseInt(getParameterByName("invoiceId")),
            postingKey: formState1?.invoice_Type == "Credit Note" ? "21" :"31",
            sglInd: "",
            tType: "",
            // paymentTerms: multipleData?.paymentTerms[0]?.ReferenceCode,
            paymentTerms: formState1?.invoice_Payment?.paymentTerms,
            paymentDays: "",
            // paymentMethod:
            // formState1?.invoice_Payment?.paymentMethod ||  formState1?.demandType === "Deposit" && "3" ,
            // paymentMethSupp:
            // formState1?.invoice_Payment?.paymentMethSupp || formState1?.demandType === "Deposit" && "P" ,
            paymentMethod: payment_method,
            paymentMethSupp: payment_method_supp,
            individualPayee: true,

            // account: vendorCode,
            account: invoiceData.vendor_Code?.Vendor_Code,
            accountName: invoiceData.vendor_Code?.Vendor_Name,
            // amount: inv_amount,
            amount: formState1?.invoice_Amount,
            taxAmount: invoiceData?.taxAmount,
            taxAmount_formatted: Number(
              invoiceData?.taxAmount
            )?.toLocaleString(),
            dueOn: moment().format("YYYY-MM-DD"),
            taxCode: invoiceData?.taxCode,
            description: formState1?.invoice_Desc,
            order: "",
            costCenter: "",
            wbsElement: "",
            profitCenter: "",
            createdBy: "",
            createdDate: moment().format("YYYY-MM-DD"),
            rowId: Math.random(),
          };
          if (
            status !== "SendToIPFromSupervisor" &&
            status !== "SendToReviewerFromSupervisor"
          ) {
            setImportPaymentDetail((formState) => ({
              ...formState,
              invoice_Payment_Details: formState1?.isHR
                ? items
                : [newItem, ...items],
            }));
          }

          // check for EFDV invoice
          // senario: in expense table and gl account table both fields are same from backend, we get data in "glAccount" keyword in getallinvoice... api,
          // in efdv invoice expense table data is entered on creating, there is no glAccount table,
          // and on other invoice there is no expense table, so in EFDV invoice senario data is load in both table(expense & GL),
          // due to which we need to make  GL Table empty.
          //  also add above condition (here ***) no need to load gl table data in pament detail table.
          // if (
          //   invoiceData?.isPCDV &&
          //   invoiceData?.GLInvoice_Accounts?.length > 0
          // ) {
          //   setFormState((formState) => ({
          //     ...formState,
          //     invoice_Accounts: [],
          //   }));
          // }
        }
      }
    };
    fetchData();
  }, [
    invoiceData?.GLInvoice_Accounts,
    formState1?.invoice_Amount,
    formState1?.invoice_Payment,
  ]);
  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: "lightgray",
      minHeight: "40px !important",
      backgroundColor: disable && "white", // Change the background color of the control
      ":focus": {
        borderColor: "gray", // Change the background color on hover
        boxShadow: "black !important",
      },
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: "white", // Change the background color of the selected option
      color: "black",
      ":hover": {
        backgroundColor: "lightgray", // Change the background color on hover
      },
    }),
    menu: (base, state) => ({
      ...base,
      backgroundColor: "white", // Change the background color of the menu
      color: "white", // Change the font color of the menu
    }),
  };

 useEffect(() => {
    const mappedArray = []
  if (formState?.invoice_Payment_Details) {
    const sortedArray = [...formState.invoice_Payment_Details].sort((a, b) => {
      // Items with postingKey "31" come first
      if (a.postingKey === "31" && b.postingKey !== "31") return -1;
      if (a.postingKey !== "31" && b.postingKey === "31") return 1;
      return 0;
    });

    mappedArray.push(...sortedArray); // Use spread to avoid nested arrays

  const shouldUseData = formState1?.invoice_No?.startsWith("FSD") ? mappedArray : formState?.invoice_Payment_Details   
  setMappedData(shouldUseData)
  }

}, [formState?.invoice_Payment_Details]);

useEffect(() => {
  if(formState1?.invoice_Type === "Final Settlement - Distributor"){
    const debitItems = formState?.invoice_Payment_Details?.filter(
    (item) => item.postingKey === "01"
  );

  if (!debitItems || debitItems.length <= 1) return; // prevent loop

  const sumAmount = debitItems.reduce(
    (acc, item) => acc + parseFloat(item.amount || 0),
    0
  );

  const combinedItem = {
    ...debitItems[0],
    amount: sumAmount,
    taxAmount: 0,
  };

  const updatedList = [
    ...formState.invoice_Payment_Details.filter((x) => x.postingKey !== "01"),
    combinedItem,
  ];

  setImportPaymentDetail((prev) => ({
    ...prev,
    invoice_Payment_Details: updatedList,
  }));
 
//  setFormState((prev) => ({
//     ...prev,
//     invoice_Accounts: updatedList,
//   }));
 
  setMappedData(updatedList);
  }
}, [
  formState1?.invoice_Type,
  formState?.invoice_Payment_Details?.length // safer
]);


  return (
    <>
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12} style={{ width: "0" }}>
          {/* sglInd: "",
           tType */}

          {/* <TableContainer component={Paper}> */}
          <Table
            aria-label="simple table"
            className={classes.table}
            size="small"
          >
            <TableHead>
              <TableRow sx={{ backgroundColor: "#EFF2F4" }}>
                <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                  Counter
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                  Post Key
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                  Account{" "}
                </TableCell>

                <TableCell
                  style={{
                    fontWeight: "bold",
                    color: "#031c30",
                  }}
                >
                  Amount
                </TableCell>
                <TableCell
                  style={{
                    fontWeight: "bold",
                    color: "#031c30",
                  }}
                >
                  Tax Amount
                </TableCell>

                <TableCell
                  style={{
                    fontWeight: "bold",
                    color: "#031c30",
                  }}
                >
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(formState?.invoice_Payment_Details?.length > 0 && mappedData?.length > 0)
                ?  mappedData?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell scope="row"> {index + 1}</TableCell>

                        {/* Post Key */}
                        <TableCell>
                          {item?.postingKey} -{" "}
                          {
                            multipleData?.postingKey?.find(
                              (x) => x?.ReferenceCode === item?.postingKey
                            )?.ReferenceText
                          }
                        </TableCell>
                        {/* Account */}
                        <TableCell>
                          {item?.account} - {item.accountName}
                        </TableCell>

                        {/* Amount */}
                        <TableCell>{addZeroes(item?.amount)}</TableCell>
                        {/* Tax Amount  */}
                        <TableCell>{addZeroes(item?.taxAmount)}</TableCell>
                        {/* Action  */}
                        {!edit &&
                        status !== "SendToIPFromSupervisor" &&
                        status !== "SendToReviewerFromSupervisor" ? (
                          <TableCell>
                            <IconButton
                              size="small"
                              onClick={() => deleteInput(index)}
                            >
                              <Delete color="error" fontSize="small" />
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={() => editItem(item)}
                            >
                              <Edit color="primary" fontSize="small" />
                            </IconButton>
                          </TableCell>
                        ) : (
                          <TableCell
                            align="center"
                            style={{
                              width: "100px",
                            }}
                          >
                            <IconButton
                              size="small"
                              onClick={() => editItem(item)}
                            >
                              <VisibilityOutlinedIcon
                                color="info"
                                fontSize="small"
                              />
                            </IconButton>
                          </TableCell>
                        )}
                      </TableRow>
                    );
                  })
                : ""}
            </TableBody>
          </Table>
          {/* </TableContainer> */}
          {!edit &&
            status !== "SendToIPFromSupervisor" &&
            status !== "SendToReviewerFromSupervisor" && (
              <Box display="flex" justifyContent={"flex-end"} mt={2}>
                <Button
                  color="secondary"
                  variant="contained"
                  onClick={handleClickOpen}
                >
                  Add New Row
                </Button>
              </Box>
            )}
        </Grid>
      </Grid>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="lg"
        fullWidth
        sx={{ height: "100%", maxHeight: "none" }}
      >
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={costLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <DialogTitle style={{ display: "flex" }} id="alert-dialog-title">
          <span style={{ borderLeft: "3px solid #0095DA" }}></span>
          <Typography
            style={{ fontWeight: "700", fontSize: "18px", marginLeft: "20px" }}
            variant="h6"
          >
            Payment Item
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1} style={{ marginTop: "2px" }}>
            {/* <DialogContentText> */}
            <Grid item xs={12} sm={12} md={4} lg={3}>
              <Typography>
                Posting Key <span className={classes.asterisk}>*</span>
              </Typography>
              <Select
                className="basic-single"
                classNamePrefix="select"
                styles={customStyles}
                // defaultValue={[taxCodeList[0]?.TaxCode]}
                maxMenuHeight={200}
                value={{
                  ReferenceCode: paymentItem?.postingKey || "",
                  ReferenceText:
                    multipleData?.postingKey?.find(
                      (x) => x?.ReferenceCode === paymentItem?.postingKey
                    )?.ReferenceText || "",
                }}
                // value={paymentItem?.postingKey}

                // defaultValue={taxCodeList}
                // isDisabled={isDisabled}
                // isLoading={isLoading}
                // isClearable={isClearable}
                // isRtl={isRtl}
                isDisabled={disable}
                isSearchable={true}
                name="color"
                onChange={(event, newValue) => {
                  autocompleteChangeHandler("postingKey", event?.ReferenceCode);
                }}
                options={multipleData?.postingKey}
                onBlur={() => setError(false)} 
                getOptionLabel={(option) =>
                  (option !== "" &&
                    `${option?.ReferenceCode} ${
                      option?.ReferenceCode ? "-" : ""
                    } ${option?.ReferenceText}`) ||
                  ""
                }
              />

              {/* <Autocomplete
                id="submitter_role"
                options={multipleData?.postingKey}
                size="small"
                value={{
                  ReferenceCode: paymentItem?.postingKey || "",
                  ReferenceText:
                    multipleData?.postingKey?.find(
                      (x) => x?.ReferenceCode === paymentItem?.postingKey
                    )?.ReferenceText || "",
                }}
                // value={formState.invoice_Payment}
                getOptionLabel={(option) =>
                  (option !== "" &&
                    `${option?.ReferenceCode}-${option?.ReferenceText}`) ||
                  ""
                }
                // loading={rolesLoading}
                onChange={(event, newValue) => {
                  autocompleteChangeHandler(
                    "postingKey",
                    newValue?.ReferenceCode
                  );
                }}
                renderInput={(params) => (
                  <TextField {...params} type="text" name="" required />
                )}
              /> */}
            </Grid>
            {(paymentItem?.postingKey == "29" ||
              paymentItem?.postingKey == "39") && (
              <Grid item xs={12} sm={12} md={4} lg={3}>
                <Typography>
                  SglInd<span className={classes.asterisk}>*</span>
                </Typography>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  styles={customStyles}
                  // defaultValue={[taxCodeList[0]?.TaxCode]}
                  maxMenuHeight={200}
                  value={{
                    ReferenceCode: paymentItem?.sglInd || "",
                    ReferenceText:
                      multipleData?.sglInd?.find(
                        (x) => x?.ReferenceCode === paymentItem?.sglInd
                      )?.ReferenceText || "",
                  }}
                  onInputChange={(inputValue, { action }) => {
                    if (action === "input-change") {
                      sortOptionsBySearchTerm(inputValue);
                    }
                  }}
                  // value={paymentItem?.sglInd}

                  // defaultValue={taxCodeList}

                  // isLoading={isLoading}
                  // isClearable={isClearable}
                  // isRtl={isRtl}
                  isDisabled={disable}
                  isSearchable={true}
                  onBlur={() => setError(false)} 
                  name="color"
                  onChange={(event, newValue) => {
                    autocompleteChangeHandler("sglInd", event?.ReferenceCode);
                  }}
                  // options={multipleData?.sglInd}
                  disabled={disable}
                  isClearable={true}
                  options={sortedOptions}
                  getOptionLabel={(option) =>
                    (option !== "" &&
                      `${option?.ReferenceCode} ${
                        option?.ReferenceCode ? "-" : ""
                      } ${option?.ReferenceText}`) ||
                    ""
                  }
                />
                {/* <Autocomplete
                  id="submitter_role"
                  options={multipleData?.sglInd}
                  size="small"
                  // value={{
                  //   ReferenceCode: paymentItem?.sglInd || "",
                  //   ReferenceText:
                  //     multipleData?.sglInd?.find(
                  //       (x) => x?.ReferenceCode === paymentItem?.sglInd
                  //     )?.ReferenceText || "",
                  // }}
                  value={paymentItem?.sglInd}
                  getOptionLabel={(option) =>
                    (option !== "" &&
                      `${option?.ReferenceCode} ${
                        option?.ReferenceCode ? "-" : ""
                      } ${option?.ReferenceText}`) ||
                    ""
                  }
                  onChange={(event, newValue) => {
                    autocompleteChangeHandler("sglInd", newValue);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} type="text" name="" required />
                  )}
                /> */}
              </Grid>
            )}
            {(paymentItem?.postingKey == "70" ||
              paymentItem?.postingKey == "75") && (
              <Grid item xs={12} sm={12} md={4} lg={3}>
                <Typography>
                  T Type<span className={classes.asterisk}>*</span>
                </Typography>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  styles={customStyles}
                  // defaultValue={[taxCodeList[0]?.TaxCode]}
                  maxMenuHeight={200}
                  value={{
                    ReferenceCode: paymentItem?.tType || "",
                    ReferenceText:
                      multipleData?.tType?.find(
                        (x) => x?.ReferenceCode === paymentItem?.tType
                      )?.ReferenceText || "",
                  }}
                  // value={paymentItem?.tType}

                  // defaultValue={taxCodeList}

                  // isLoading={isLoading}
                  // isClearable={isClearable}
                  // isRtl={isRtl}
                  isDisabled={disable}
                  isSearchable={true}
                  name="color"
                  onChange={(event, newValue) => {
                    autocompleteChangeHandler("tType", event?.ReferenceCode);
                  }}
                  options={multipleData?.tType}
                  getOptionLabel={(option) =>
                    (option !== "" &&
                      `${option?.ReferenceCode} ${
                        option?.ReferenceCode ? "-" : ""
                      } ${option?.ReferenceText}`) ||
                    ""
                  }
                  disable={disable}
                />
                {/* <Autocomplete
                  id="submitter_role"
                  options={multipleData?.tType}
                  size="small"
                  value={{
                    ReferenceCode: paymentItem?.tType || "",
                    ReferenceText:
                      multipleData?.tType?.find(
                        (x) => x?.ReferenceCode === paymentItem?.tType
                      )?.ReferenceText || "",
                  }}
                  // value={formState.invoice_Payment}
                  getOptionLabel={(option) =>
                    (option !== "" &&
                      `${option?.ReferenceCode}- ${option?.ReferenceText}`) ||
                    ""
                  }
                  // value={formState.invoice_Payment}
                  onChange={(event, newValue) => {
                    autocompleteChangeHandler("tType", newValue?.ReferenceCode);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} type="text" name="" required />
                  )}
                /> */}
              </Grid>
            )}
            {(paymentItem?.postingKey == "40" || 
              paymentItem?.postingKey == "01" ||
              paymentItem?.postingKey == "50") && (
              <Grid item xs={12} sm={12} md={4} lg={3}>
                <Typography>{formState1?.invoice_Type === "Final Settlement - Distributor" ? "Customer Account" : "GL Account"}</Typography>
                <FormControl fullWidth size="small">
                  <GetChargeAccount
                    GLAccount={paymentItem?.account}
                    changeHandler={changeHandler}
                    // index={index}
                    disabled={disable}
                    bordered={true}
                    setAlertMessage={setAlertMessage}
                    setErrAlertMessage={setErrAlertMessage}
                  />
                </FormControl>
              </Grid>
            )}
            {(paymentItem?.postingKey == "70" ||
              paymentItem?.postingKey == "75") && (
              <Grid item xs={12} sm={12} md={4} lg={3}>
                <Typography>Asset Number</Typography>
                <TextField
                  fullWidth
                  size="small"
                  name="account"
                  type="text"
                  value={paymentItem?.account}
                  sx={{
                    // width: "70%",
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  onChange={changeHandler}
                  id="outlined-basic"
                  variant="outlined"
                  inputProps={{ maxLength: 10 }}
                  disable={disable}
                />
              </Grid>
            )}
            {(paymentItem?.postingKey == "21" ||
              paymentItem?.postingKey == "29" ||
              paymentItem?.postingKey == "31" ||
              paymentItem?.postingKey == "39") && (
              <Grid item xs={12} sm={12} md={4} lg={3}>
                <FormControl fullWidth size="small">
                  <Typography>Vendor Code </Typography>
                  {/* <VendorCodeImport
                    // disabled={selectedRole === "Import"}
                    user={
                      paymentItem?.vendor_Code?.Vendor_Code ||
                      paymentItem?.vendor_Code
                    }
                    formState={paymentItem}
                    setImportPaymentDetail={setPaymentItem}
                    changeHandler={changeHandler}
                  /> */}

                  <VendorCode
                    disabled={disable}
                    setFormState={setPaymentItem}
                    formState={paymentItem}
                    changeHandler={changeHandler}
                    bordered={true}
                    user={paymentItem?.vendor_Code?.Vendor_Code}
                    setvendorblock={setvendorblock}
                    setErrAlertMessage={setErrAlertMessage}
                  />
                </FormControl>
              </Grid>
            )}
            <Grid item xs={12} sm={12} md={4} lg={3}>
              <Typography>Amount</Typography>
              <TextField
                fullWidth
                size="small"
                name="amount"
                type="text"
                pattern="[0-9]*"
                InputProps={{
                  inputProps: { min: 1, inputMode: "numeric" },
                }}
                // value={paymentItem.amount}
                value={paymentItem.amount_formatted}
                sx={{
                  // width: "70%",
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                id="outlined-basic"
                variant="outlined"
                onChange={changeHandler}
                disabled={disable}
                 onBlur={() => setError(false)} 
              />
             {isError ? (
  <span style={{ color: "red" }}>
    Amount cannot be greater than Advance Amount
  </span>
) : null}

            </Grid>
            {(paymentItem?.postingKey == "70" ||
              paymentItem?.postingKey == "75") && (
              <Grid item xs={12} sm={12} md={4} lg={3}>
                <Typography>Order</Typography>
                <TextField
                  fullWidth
                  size="small"
                  name="order"
                  type="text"
                  value={paymentItem?.order}
                  sx={{
                    // width: "70%",
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  id="outlined-basic"
                  variant="outlined"
                  onChange={changeHandler}
                  disabled={disable}
                />
              </Grid>
            )}

            {(paymentItem?.postingKey == "21" ||
              paymentItem?.postingKey == "29" ||
              paymentItem?.postingKey == "31" ||
              paymentItem?.postingKey == "50" ||
              paymentItem?.postingKey == "39") && (
              <Grid item xs={12} sm={12} md={4} lg={3}>
                <Typography>Tax Amount</Typography>
                <TextField
                  fullWidth
                  size="small"
                  name="taxAmount"
                  // type="text"
                  type="text"
                  pattern="[0-9]*"
                  InputProps={{
                    inputProps: { min: 1, inputMode: "numeric" },
                  }}
                  value={paymentItem.taxAmount_formatted}
                  // value={paymentItem?.taxAmount}
                  sx={{
                    // width: "70%",
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  id="outlined-basic"
                  variant="outlined"
                  onChange={changeHandler}
                  disabled={disable}
                />
              </Grid>
            )}
            {(paymentItem?.postingKey == "21" ||
              paymentItem?.postingKey == "29" ||
              paymentItem?.postingKey == "31" ||
              paymentItem?.postingKey == "40" || 
              paymentItem?.postingKey == "01" ||
              paymentItem?.postingKey == "50" ||
              paymentItem?.postingKey == "70" ||
              paymentItem?.postingKey == "75" ||
              paymentItem?.postingKey == "39") && (
              <Grid item xs={12} sm={12} md={4} lg={3}>
                <Typography>Tax Code</Typography>
                {/* <Autocomplete
                  id="selectedTaxCode"
                  options={taxCodeList}
                  size="small"
                  value={{
                    TaxCode: paymentItem?.taxCode || "",
                    Description:
                      taxCodeList?.find(
                        (x) => x.TaxCode === paymentItem?.taxCode
                      )?.Description || "",
                  }}
                  onChange={(event, newValue) => {
                    autocompleteChangeHandler("taxCode", newValue?.TaxCode);
                  }}
                  // value={selectedTaxCode}
                  getOptionLabel={(option) =>
                    (option !== "" &&
                      `${option?.TaxCode} ${option?.TaxCode ? "-" : ""} ${
                        option?.Description
                      }`) ||
                    ""
                  }
                  key={(option) => option?.TaxCode}
                  loading={taxCodeListLoading}
                  renderInput={(params) => (
                    <TextField {...params} type="text" name="" required />
                  )}
                /> */}

                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  styles={customStyles}
                  maxMenuHeight={200}
                  value={{
                    TaxCode: paymentItem?.taxCode || "",
                    Description:
                      taxCodeList?.find(
                        (x) => x.TaxCode === paymentItem?.taxCode
                      )?.Description || "",
                  }}
                  isDisabled={disable}
                  isSearchable={true}
                  isClearable={true}
                  name="color"
                  onChange={(newValue, actionMeta) => {
                    if (actionMeta.action === "clear") {
                      // Handle clear action
                      autocompleteChangeHandler("taxCode", ""); // or whatever logic you need
                    } else if (newValue?.TaxCode) {
                      autocompleteChangeHandler("taxCode", newValue?.TaxCode);
                    }
                  }}
                  // onChange={(event, newValue) => {
                  //   if (event?.TaxCode) {
                  //     // setFormState((formState) => ({
                  //     //   ...formState,
                  //     //   salesTaxCode: event?.TaxCode || "",
                  //     //   // salesTaxAmount: formState?.calculateTax
                  //     //   //   ? event?.DefaultValue
                  //     //   //   : formState.salesTaxAmount,
                  //     // }));
                  //     autocompleteChangeHandler("taxCode", event?.TaxCode);
                  //   }
                  // }}
                  options={taxCodeList}
                  getOptionLabel={(option) =>
                    (option !== "" &&
                      `${option?.TaxCode} ${option?.TaxCode ? "-" : ""} ${
                        option?.Description
                      }`) ||
                    ""
                  }
                />
              </Grid>
            )}
            {(paymentItem?.postingKey == "40" || 
              paymentItem?.postingKey == "01" ||
              paymentItem?.postingKey == "50") && (
              <Grid item xs={12} sm={12} md={4} lg={3}>
                <Typography>Wbs Element</Typography>
                <TextField
                  type="text"
                  name="wbsElement"
                  size="small"
                  value={paymentItem?.wbsElement || paymentItem?.WBSElement}
                  // disabled={disabled}
                  sx={{
                    width: "100%",
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  disabled={paymentItem?.costCenter || disable ? true : false}
                  id="outlined-basic"
                  variant="outlined"
                  onChange={changeHandler}
                />
              </Grid>
            )}
            {(paymentItem?.postingKey == "29" ||
              paymentItem?.postingKey == "40" || 
              paymentItem?.postingKey == "01" ||
              paymentItem?.postingKey == "50" ||
              paymentItem?.postingKey == "39") && (
              <Grid item xs={12} sm={12} md={4} lg={3}>
                <Typography>Profit Center</Typography>
                <TextField
                  type="text"
                  name="profitCenter"
                  size="small"
                  value={paymentItem?.profitCenter || paymentItem?.profitCenter}
                  // disabled={disabled}
                  sx={{
                    width: "100%",
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  id="outlined-basic"
                  variant="outlined"
                  disabled={paymentItem?.costCenter || disable ? true : false}
                  onChange={changeHandler}
                />
              </Grid>
            )}
            {(paymentItem?.postingKey == "40" || 
              paymentItem?.postingKey == "01" ||
              paymentItem?.postingKey == "50") && (
              <Grid item xs={12} sm={12} md={4} lg={3}>
                <Typography>Cost Center</Typography>
                <FormControl fullWidth size="small">
                  <CostCenter
                    // value={paymentItem?.costCenter || paymentItem?.CostCenter}
                    value={
                      paymentItem?.costCenter || ""
                      // paymentItem?.CostCenter || {
                      //   CostCenterCode: "",
                      //   Name: "",
                      // }
                    }
                    costCenter={
                      paymentItem?.costCenter || paymentItem?.CostCenter || ""
                    }
                    disabled={
                      paymentItem.profitCenter || disable ? true : false
                    }
                    changeHandler={changeHandler}
                    bordered={true}
                    setAlertMessage={setAlertMessage}
                    setErrAlertMessage={setErrAlertMessage}
                  />
                </FormControl>
              </Grid>
            )}
            {(paymentItem?.postingKey == "29" ||
              paymentItem?.postingKey == "39") && (
              <Grid item xs={12} sm={12} md={4} lg={3}>
                <Typography>
                  Due Date <span className={classes.asterisk}>*</span>
                </Typography>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={paymentItem?.dueOn || paymentItem?.DueOn || ""}
                    onChange={(newValue) => {
                      autocompleteChangeHandler("dueOn", newValue);
                    }}
                    error={false}
                    renderInput={(params) => (
                      <TextField
                        fullWidth
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        {...params}
                        error={false}
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        disabled={disable}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
            )}
            {(paymentItem?.postingKey == "21" ||
              paymentItem?.postingKey == "31") && (
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                lg={3}
                style={{ paddingRight: "18px" }}
              >
                <Typography>Baseline Date</Typography>

                {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={paymentItem?.createdDate || paymentItem?.CreatedDate}
                    inputProps={{ readOnly: true }}
                    shouldDisableDate={isAboveToday}
                    onChange={(newValue) => {
                      isOldDateValidate(
                        formatDateTimeForBackend(newValue),
                        setOpenInvalidWarningDate
                      );
                      autocompleteChangeHandler("createdDate", newValue);
                    }}
                    name=""
                    error={false}
                    renderInput={(params) => (
                      <TextField
                        fullWidth
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        {...params}
                        error={false}
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                      />
                    )}
                  />
                </LocalizationProvider>
              */}

                <input
                  // className={classes.inputField}
                  style={myStyle.inputField}
                  name="createdDate"
                  type="date"
                  max="9999-12-31"
                  value={paymentItem?.createdDate || paymentItem?.CreatedDate}
                  onChange={(e) => {
                    autocompleteChangeHandler(
                      "createdDate",
                      e.target.value,
                      formatDateTimeForBackend(e)
                    );
                  }}
                  disabled={disable}
                />
              </Grid>
            )}
            {(paymentItem?.postingKey == "21" ||
              paymentItem?.postingKey == "31") && (
              <Grid item xs={12} sm={12} md={4} lg={3}>
                <Typography>
                  Payment Terms <span className={classes.asterisk}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  name="paymentTerms"
                  size="small"
                  type="text"
                  value={paymentItem?.paymentTerms}
                  id="outlined-basic"
                  variant="outlined"
                  disabled
                  onChange={changeHandler}
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                />
              </Grid>
            )}
            {(paymentItem?.postingKey == "21" ||
              paymentItem?.postingKey == "29" ||
              paymentItem?.postingKey == "31" ||
              paymentItem?.postingKey == "39") && (
              <Grid item xs={12} sm={12} md={4} lg={3}>
                <Typography>
                  Payment Method <span className={classes.asterisk}>*</span>
                </Typography>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  styles={customStyles}
                  maxMenuHeight={200}
                  menuShouldScrollIntoView={true}
                  value={{
                    ReferenceCode: paymentItem?.paymentMethod || "",
                    ReferenceText:
                      multipleData?.paymentMethod?.find(
                        (x) => x?.ReferenceCode === paymentItem?.paymentMethod
                      )?.ReferenceText || "",
                  }}
                  isSearchable={true}
                  name="paymentMethod"
                  onChange={(event, newValue) => {
                    autocompleteChangeHandler(
                      "paymentMethod",
                      event?.ReferenceCode
                    );
                  }}
                  options={multipleData?.paymentMethod}
                  getOptionLabel={(option) =>
                    (option !== "" &&
                      `${option?.ReferenceCode} ${
                        option?.ReferenceCode ? "-" : ""
                      } ${option?.ReferenceText}`) ||
                    ""
                  }
                  isDisabled={disable}
                />
                {/* <Autocomplete
                  id="submitter_role"
                  options={multipleData?.paymentMethod}
                  size="small"
                  value={{
                    ReferenceCode: paymentItem?.paymentMethod || "",
                    ReferenceText:
                      multipleData?.paymentMethod?.find(
                        (x) => x?.ReferenceCode === paymentItem?.paymentMethod
                      )?.ReferenceText || "",
                  }}
                  // value={formState.invoice_Payment}
                  getOptionLabel={(option) =>
                    (option !== "" &&
                      `${option?.ReferenceCode}- ${option?.ReferenceText}`) ||
                    ""
                  }
                  // loading={rolesLoading}
                  onChange={(event, newValue) => {
                    autocompleteChangeHandler(
                      "paymentMethod",
                      newValue?.ReferenceCode
                    );
                  }}
                  renderInput={(params) => (
                    <TextField {...params} type="text" name="" required />
                  )}
                /> */}
              </Grid>
            )}
            {(paymentItem?.postingKey == "21" ||
              paymentItem?.postingKey == "29" ||
              paymentItem?.postingKey == "31" ||
              paymentItem?.postingKey == "39") && (
              <Grid item xs={12} sm={12} md={4} lg={3}>
                <Typography>
                  Payment Method Supp{" "}
                  <span className={classes.asterisk}>*</span>
                </Typography>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  styles={customStyles}
                  maxMenuHeight={200}
                  value={{
                    ReferenceCode: paymentItem?.paymentMethSupp || "",
                    ReferenceText:
                      multipleData?.paymentMethSupp?.find(
                        (x) => x?.ReferenceCode === paymentItem?.paymentMethSupp
                      )?.ReferenceText || "",
                  }}
                  isSearchable={true}
                  name="paymentMethSupp"
                  onChange={(event, newValue) => {
                    autocompleteChangeHandler(
                      "paymentMethSupp",
                      event?.ReferenceCode
                    );
                  }}
                  options={multipleData?.paymentMethSupp}
                  getOptionLabel={(option) =>
                    (option !== "" &&
                      `${option?.ReferenceCode} ${
                        option?.ReferenceCode ? "-" : ""
                      } ${option?.ReferenceText}`) ||
                    ""
                  }
                  isDisabled={disable}
                />
                {/* <Autocomplete
                  id="submitter_role"
                  options={multipleData?.paymentMethSupp}
                  size="small"
                  value={{
                    ReferenceCode: paymentItem?.paymentMethSupp || "",
                    ReferenceText:
                      multipleData?.paymentMethSupp?.find(
                        (x) => x?.ReferenceCode === paymentItem?.paymentMethSupp
                      )?.ReferenceText || "",
                  }}
                  // value={formState.invoice_Payment}
                  getOptionLabel={(option) =>
                    (option !== "" &&
                      `${option?.ReferenceCode}- ${option?.ReferenceText}`) ||
                    ""
                  }
                  onChange={(event, newValue) => {
                    autocompleteChangeHandler(
                      "paymentMethSupp",
                      newValue.ReferenceCode
                    );
                  }}
                  renderInput={(params) => (
                    <TextField {...params} type="text" name="" required />
                  )}
                /> */}
              </Grid>
            )}
            {/* {
               (paymentItem?.postingKey == "39" && formState1?.adjustAdvance && paymentItem?.sglInd == "A" ) && (
              <>
              <Grid item xs={12} sm={12} md={4} lg={3}>
               <Typography>Advance Doc No</Typography>
            <Select
             className="basic-single"
              classNamePrefix="select"
               styles={customStyles}
               maxMenuHeight={200}
              value={paymentItem?.advanceDocNo ? { value: paymentItem.advanceDocNo, label: paymentItem.advanceDocNo } : null}
              isSearchable={true}
               name="advanceDocNo"
           onChange={(selectedOption) => {
          autocompleteChangeHandler("advanceDocNo", selectedOption?.value);
         }}
            options={docNos.map((doc) => ({ value: doc, label: doc }))}
              getOptionLabel={(option) => option.label}
          getOptionValue={(option) => option.value}
        isDisabled={disable}
/>
                </Grid>
                   <Grid item xs={12} sm={12} md={4} lg={3}>
               <Typography>Adjust Advance Amount</Typography>
              <TextField
                fullWidth
                size="small"
                name="advanceAmount"
                type="text"
                pattern="[0-9]*"
                InputProps={{
                  inputProps: { min: 1, inputMode: "numeric" },
                }}
                // value={paymentItem.amount}
                value={ paymentItem.advanceAmount && (paymentItem.advanceAmount?.toLocaleString())}
                sx={{
                  // width: "70%",
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                id="outlined-basic"
                variant="outlined"
                onChange={changeHandler}
                disabled={true}
                required={true}
              />
                </Grid>
              </>
               )}   */}
            {(paymentItem?.postingKey == "21" ||
              paymentItem?.postingKey == "29" ||
              paymentItem?.postingKey == "31" ||
              paymentItem?.postingKey == "39") && (
              <Grid item xs={12} sm={12} md={4} lg={3}>
                <FormControlLabel
                  style={{ margin: "20px 0px" }}
                  label="Ind. Payee"
                  color="secondary"
                  disabled={disable}
                  control={
                    <Checkbox
                      color="secondary"
                      fontSize="small"
                      checked={paymentItem?.individualPayee}
                      onChange={(event) => {
                        setPaymentItem((formState) => ({
                          ...formState,
                          individualPayee: event.target.checked,
                        }));
                      }}
                    />
                  }
                />
              </Grid>
            )}
          </Grid>
          <Grid container item xs={12} sm={12} md={6} lg={6}>
            <Typography>Text</Typography>
            <TextField
              fullWidth
              size="small"
              name="description"
              type="text"
              sx={{
                // width: "70%",
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              value={paymentItem?.description}
              id="outlined-basic"
              onChange={changeHandler}
              variant="outlined"
              disabled={disable}
            />
          </Grid>
          {alertMessage && (
            <POAlertDialog
              setAlertMessage={setAlertMessage}
              message={erralertMessage}
            />
          )}

          {openInvalidWarningDate && (
            <OldDateWarning
              open={openInvalidWarningDate}
              close={() => setOpenInvalidWarningDate(false)}
            />
          )}
          {/* </DialogContentText> */}
          <DialogActions>
            <Button color="primary" variant="outlined" onClick={handleClose}>
              Close
            </Button>
            <Button color="secondary" variant="contained" onClick={addItem}>
              Submit
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default PaymentDetailTable;

/* icon */

// position: absolute;
// left: 70.57%;
// right: 16.75%;
// top: 38.75%;
// bottom: 38.52%;

// /* Vector */

// position: absolute;
// left: 70.57%;
// right: 16.75%;
// top: 38.75%;
// bottom: 38.52%;

// background: #C5C7CD;

// /* Vector */

// position: absolute;
// left: 72.81%;
// right: 19.02%;
// top: 46.57%;
// bottom: 45.65%;

// background: #C5C7CD;

// /* Vector */

// position: absolute;
// left: 76.12%;
// right: 22.33%;
// top: 48.31%;
// bottom: 48.98%;

// background: #C5C7CD;

// /* Vector */

// position: absolute;
// left: 79.61%;
// right: 19.54%;
// top: 40.14%;
// bottom: 59.34%;

// background: #C5C7CD;

// /* Vector */

// position: absolute;
// left: 75.43%;
// right: 19.54%;
// top: 41.56%;
// bottom: 57.91%;

// background: #C5C7CD;

// /* Vector */

// position: absolute;
// left: 75.43%;
// right: 19.54%;
// top: 43.48%;
// bottom: 56%;

// background: #C5C7CD;

// /* Vector */

// position: absolute;
// left: 73.18%;
// right: 19.54%;
// top: 55.74%;
// bottom: 43.74%;

// background: #C5C7CD;

/* Vector */

// position: absolute;
// left: 78.18%;
// right: 20.97%;
// top: 40.14%;
// bottom: 59.34%;

// background: #C5C7CD;
